module.exports = __webpack_public_path__ + "media/images/area/area_kansaiM400-681a52b4b18caf0955ff953fd2f52afb.jpg";